import { SELECIONAR_ENDERECO_REMETENTE } from '../types'

export default function selecionarEnderecoRemetente (endereco) {
  return {
    type: SELECIONAR_ENDERECO_REMETENTE,
    payload: endereco
  }
}
